<div class="card border-0 header">
  <h3>{{ titulo }}</h3>
  <div class="card-body">
    <!-- https://getbootstrap.com/docs/4.0/utilities/display/ -->
    <div class="row mb-2">
      <div class="col">
        <label>Data Operação</label>
        <span
          data-cy="operationDate"
          *ngIf="operationDate != null"
          class="d-block p-2 bg-dark text-white text-center"
        >
          {{ operationDate | date: "dd/MM/yyyy" }}
        </span>
      </div>
      <div class="col">
        <label *ngIf="id">Código</label>
        <span
          *ngIf="id"
          data-cy="idBoleta"
          class="d-block p-2 bg-dark text-white text-center"
        >
          {{ id }}
        </span>
      </div>
      <div class="col">
        <label>&nbsp;</label>
        <span
          data-cy="statusDescription"
          class="d-block p-2 bg-dark text-white text-center"
        >
          {{ statusDescription || "Em Elaboração" }}
        </span>
      </div>
    </div>
    <div class="row mb-2" *ngIf="accountManagerName">
      <div class="col">
        <label>Nome do Gestor</label>
        <span class="d-block p-2 bg-dark text-white text-center">
          {{ accountManagerName }}
        </span>
      </div>
      <div class="col">
        <label>CNPJ Gestor</label>
        <span class="d-block p-2 bg-dark text-white text-center">
          {{ accountManagerDocument }}
        </span>
      </div>
    </div>
  </div>
</div>
